import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

import favicon from "../images/favicon.png";

import "./index.css";

const TemplateWrapper = ({ children }) => (
    <div>
        <Helmet>
            <link rel="dns-prefetch" href="//fonts.googleapis.com/" />
            <link
                href="https://fonts.googleapis.com/css?family=Fira+Mono:500|Open+Sans:400,700&amp;subset=latin-ext"
                rel="stylesheet"
            />
            <link rel="shortcut icon" href={favicon} />
        </Helmet>
        {children()}
    </div>
);

TemplateWrapper.propTypes = {
    children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js